import { HttpInterface } from '@core/http';
import { PackageApiEndpoint } from '@api-endpoint';
import {
  FetchPackageResponse,
  FetchPackageAmountPayload,
  RequestPackagePayload,
  FetchPackageReservationPayload,
  PackageReservationListResponse,
} from '@dto';
import {
  FetchPackageCalenderPayload,
  FetchPackageCalenderResponse,
  PackageReservationDetailResponse,
} from '@core/dto';
export class PackageAdapter {
  http: HttpInterface;
  constructor(httpInstance: HttpInterface) {
    this.http = httpInstance;
  }
  async fetchPackageList(): Promise<FetchPackageResponse> {
    const response = await this.http.get<FetchPackageResponse>(
      PackageApiEndpoint.fetchPackageList
    );
    return response.data;
  }
  async fetchCalenderPackageList(
    payload: FetchPackageCalenderPayload
  ): Promise<FetchPackageCalenderResponse[]> {
    const response = await this.http.get<FetchPackageCalenderResponse[]>(
      PackageApiEndpoint.fetchPackageCalenderList,
      payload
    );
    return response.data;
  }
  async fetchPackageAmount(
    payload: FetchPackageAmountPayload
  ): Promise<number> {
    const response = await this.http.get<number>(
      PackageApiEndpoint.fetchPackageAmount,
      payload
    );
    return response.data;
  }
  async requestPackage(payload: RequestPackagePayload): Promise<void> {
    await this.http.post<void>(PackageApiEndpoint.requestPackage, payload);
  }

  async fetchPackageReservationList(
    payload: FetchPackageReservationPayload
  ): Promise<PackageReservationListResponse> {
    const response = await this.http.get<PackageReservationListResponse>(
      PackageApiEndpoint.fetchPackageReservationList,
      payload
    );
    return response.data;
  }
  async fetchPackageReservationDetail(payload: {
    rresveNo: number;
  }): Promise<PackageReservationDetailResponse> {
    const response = await this.http.get<PackageReservationDetailResponse>(
      PackageApiEndpoint.fetchPackageReservationDetail,
      payload
    );
    return response.data;
  }
  async cancelPackageReservation(payload: { resveNo: number }): Promise<void> {
    const { resveNo } = payload;
    const url = this.http.replacedUrl(
      PackageApiEndpoint.cancelPackageReservation,
      {
        resveNo,
      }
    );
    await this.http.put<void>(url);
  }
}
